import AnimateButton from '@/components/general/button-custom/AnimateButton';
import Navbar from '@/components/layout/menu-bar/Navbar';
import Sidebar from '@/components/layout/menu-bar/Sidebar';
import { useStore } from '@/hooks/useStore';
import { getTitlePage } from '@/utils/routes';
import { cn } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import { ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

interface AdminPanelLayoutProps {
    isTakeAllSpace?: boolean,
    showCenter?: boolean,
    children?: string | number | boolean | Element | ReactNode | Iterable<ReactNode>
}
export default observer(function AdminPanelLayout({ isTakeAllSpace = false, showCenter = false }: AdminPanelLayoutProps) {
    // hooks
    const { t } = useTranslation();
    const { pathname, state } = useLocation();
    const navigate = useNavigate();

    // variables
    const { title, pathKey, showBtnBack }: any = getTitlePage(pathname);

    // store
    const {
        uiStore: { isOpenSidebar },
        authStore: { getProfile }
    } = useStore();

    // lifecycle
    useEffect(() => {
        getProfile();
    }, [pathname]);

    // functions
    const handleGoBack = () => {
        if (state?.previousUrl) {
            navigate(state?.previousUrl);
        } else {
            const basePath = pathKey.split('/')[0];

            if (pathname.includes(basePath)) {
                const newPath = pathname.split(basePath)[0] + basePath;
                navigate(newPath);
            }
        }
    };

    return (
        <>
            <Sidebar />
            <main
                className={cn(
                    'min-h-[calc(100vh)] bg-background-4 transition-[margin-left] ease-in-out duration-300',
                    isOpenSidebar === false ? 'lg:ml-[90px]' : 'lg:ml-72',
                    isTakeAllSpace && 'bg-white'
                )}
            >
                <Navbar />
                <div className='md:py-6 px-4 py-4 sm:px-8'>
                    <div
                        className={cn(
                            'flex md:justify-between md:items-center gap-1',
                            title && 'min-h-[44px]'
                        )}
                    >
                        {title ? <h1 className='text-2xl title-page'>{t(title)}</h1> : <div></div>}
                        {showBtnBack && (
                            <AnimateButton
                                type='button'
                                outline
                                side='left'
                                contentComp={t('button.back_to_screen')}
                                parentClassName='h-[44px] hidden md:flex'
                                className='w-fit px-3 rounded-button'
                                textClassName='!text-[14px] !pl-6.5'
                                iconArrowClassName='size-[15px]'
                                onClick={handleGoBack}
                            />
                        )}
                    </div>
                    <div
                        className={cn(
                            'mt-2 gap-6 min-h-[calc(100vh-64px-20px-24px-56px-28px+16px)]',
                            title && 'md:mt-6',
                            showCenter && 'flex'
                        )}
                    >
                        <div className='flex-1'>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
});
